import { primaryKey, editableOnNew, headerCode, inputType, required, length, order, pattern, editable, Describer, visible, GceEntity, textAlign, relation } from './gce-management';
import { GceInvoicePerson } from './gce-invoice-person';
import { GceMedicType } from './gce-medic-type';

/**
 * GcePrint3d -> table: fmc_stampe3d_eseguite
 * 
 */
export class GcePrint3d extends GceEntity {
    @primaryKey()
    @headerCode('GCE.GCEPRINT3D.PreventivoPrestazioneId')
    @inputType('number')
    @visible(true)
    @order(1)
    PreventivoPrestazioneId: number;

    @headerCode('GCE.GCEPRINT3D.idfatturazione')
    @inputType('dtselect')
    @required()
    @relation("GceMedics", { columnRel: 'idfatturazione', columnDescr: ['descrizione'] })
    @visible(true)
    @order(2)
    idfatturazione: number;

    @headerCode('GCE.GCEPRINT3D.cod_clinica_stampatrice')
    @inputType('text')
    @visible(true)
    @length(255)
    @order(3)
    cod_clinica_stampatrice: string;

    @headerCode('GCE.GCEPRINT3D.cod_clinica_cliente')
    @inputType('text')
    @visible(true)
    @length(255)
    @order(3)
    cod_clinica_cliente: string;

    @headerCode('GCE.GCEPRINT3D.DataCompetenza')
    @inputType('date')
    @visible(true)
    @order(4)
    DataCompetenza: Date | string;

    @headerCode('GCE.GCEPRINT3D.OperatoreDescrizione')
    @inputType('text')
    @visible(true)
    @length(255)
    @order(5)
    OperatoreDescrizione: string;

    @headerCode('GCE.GCEPRINT3D.CodicePaziente')
    @inputType('text')
    @visible(true)
    @length(255)
    @order(6)
    CodicePaziente: string;

    @headerCode('GCE.GCEPRINT3D.NomePaziente')
    @inputType('text')
    @visible(true)
    @length(255)
    @order(7)
    NomePaziente: string;

    @headerCode('GCE.GCEPRINT3D.CognomePaziente')
    @inputType('text')
    @visible(true)
    @length(255)
    @order(8)
    CognomePaziente: string;

    @headerCode('GCE.GCEPRINT3D.PreventivoPrestazioneDescrizione')
    @inputType('text')
    @visible(true)
    @length(255)
    @order(9)
    PreventivoPrestazioneDescrizione: string;

    @headerCode('GCE.GCEPRINT3D.PreventivoNumero')
    @inputType('number')
    @visible(true)
    @editableOnNew(false)
    @order(10)
    PreventivoNumero: number;

    @headerCode('GCE.GCEPRINT3D.DataPreventivo')
    @inputType('date')
    @visible(true)
    @order(11)
    DataPreventivo: Date | string;

    @headerCode('GCE.GCEPRINT3D.ClinicaIdSistemaOrigine')
    @inputType('text')
    @visible(false)
    @length(255)
    @order(12)
    ClinicaIdSistemaOrigine: string;

    @headerCode('GCE.GCEPRINT3D.ClinicaId')
    @inputType('number')
    @visible(false)
    @editableOnNew(false)
    @order(13)
    ClinicaId: number;

    @headerCode('GCE.GCEPRINT3D.PrestazioneId')
    @inputType('number')
    @visible(true)
    @editableOnNew(false)
    @order(14)
    PrestazioneId: number;

    @headerCode('GCE.GCEPRINT3D.PreventivoId')
    @inputType('number')
    @visible(true)
    @editableOnNew(false)
    @order(15)
    PreventivoId: number;

    person?: GceInvoicePerson;

    constructor();
    constructor(
        PreventivoPrestazioneId: number,
        idfatturazione: number,
        cod_clinica_stampatrice: string,
        cod_clinica_cliente: string,
        DataCompetenza: Date | string,
        OperatoreDescrizione: string,
        CodicePaziente: string,
        NomePaziente: string,
        CognomePaziente: string,
        PreventivoPrestazioneDescrizione: string,
        PreventivoNumero: number,
        DataPreventivo: Date | string,
        ClinicaIdSistemaOrigine: string,
        ClinicaId: number,
        PrestazioneId: number,
        PreventivoId: number
    );
    constructor(PreventivoPrestazioneId?: number,
        idfatturazione?: number,
        cod_clinica_stampatrice?: string,
        cod_clinica_cliente?: string,
        DataCompetenza?: Date | string,
        OperatoreDescrizione?: string,
        CodicePaziente?: string,
        NomePaziente?: string,
        CognomePaziente?: string,
        PreventivoPrestazioneDescrizione?: string,
        PreventivoNumero?: number,
        DataPreventivo?: Date | string,
        ClinicaIdSistemaOrigine?: string,
        ClinicaId?: number,
        PrestazioneId?: number,
        PreventivoId?: number) {
        super();
        this.PreventivoPrestazioneId = PreventivoPrestazioneId || 0;
        this.idfatturazione = idfatturazione || 0;
        this.cod_clinica_stampatrice = cod_clinica_stampatrice || '';
        this.cod_clinica_cliente = cod_clinica_cliente || '';
        this.DataCompetenza = DataCompetenza || '';
        this.OperatoreDescrizione = OperatoreDescrizione || '';
        this.CodicePaziente = CodicePaziente || '';
        this.NomePaziente = NomePaziente || '';
        this.CognomePaziente = CognomePaziente || '';
        this.PreventivoPrestazioneDescrizione = PreventivoPrestazioneDescrizione || '';
        this.PreventivoNumero = PreventivoNumero || 0;
        this.DataPreventivo = DataPreventivo || '';
        this.ClinicaIdSistemaOrigine = ClinicaIdSistemaOrigine || '';
        this.ClinicaId = ClinicaId || 0;
        this.PrestazioneId = PrestazioneId || 0;
        this.PreventivoId = PreventivoId || 0;
    }

    static getStructure(): Array<any> {
        let structure: any[] = Describer.getStructure(new GcePrint3d());
        structure.push(...this.getActions());
        return structure;
    }

    protected static getActions(): any[] {
        let actions: any[] = [];
        return actions;
    }
}
